import isIE11 from 'utils/isIE11';
import checkmark from './icons/checkmark.svg';

const checkboxStyles = ({ oaoButtons: buttons, palette, spacing }) => ({
  '&::after': {
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    content: '""',
    display: 'block',
    height: 16,
    left: -2,
    position: 'absolute',
    top: -2,
    width: 16,
  },
  '&::before': {
    background: ({ readOnly }) => (readOnly ? 'white' : palette.background),
    border: ({ readOnly }) => (readOnly ? 'none' : `1px solid ${palette.grey.light}`),
    borderRadius: spacing.unit,
    content: '""',
    display: 'block',
    height: 24,
    left: -6,
    position: 'relative',
    top: -6,
    width: 24,
  },
  '&:checked::after': {
    background: isIE11 ? `transparent url(${checkmark}) 0 50% no-repeat` : buttons.primary.color,
    maskImage: isIE11 ? 'none' : `url(${checkmark})`,
  },
  '&:checked::before': {
    background: buttons.primary.background,
    border: 'none',
  },
  '&:disabled::before': {
    background: palette.grey.normal,
  },
  '&:disabled:checked::after': {
    background: isIE11 ? `transparent url(${checkmark}) 0 50% no-repeat` : buttons.primary.color,
    maskImage: isIE11 ? 'none' : `url(${checkmark})`,
  },
  position: 'relative',
});

export default checkboxStyles;
